import useLoginService from './login.service';
import useLogoutService from './logout.service';

export default { useLoginService, useLogoutService };
